<nz-modal
  [nzMaskClosable]="false"
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzClosable]="!cartonStep"
  [nzKeyboard]="!cartonStep"
  (nzOnCancel)="handleCancel()"
  (nzAfterOpen)="afterModalOpen()"
  nzWidth="100%"
  nzClassName="ship-process-modal"
  >
  <ng-template #modalTitle>{{ title }}</ng-template>

  <ng-template #modalContent>
    <div class="process-header">
      <div class="scan-field">
        <span>Die Bestellnummer scannen:</span>
        <span class="scan-field__control">
          <input [(ngModel)]="orderNumber" (ngModelChange)="handleNumberScan($event)" appPossitiveNumbers #scanField cdkFocusInitial nz-input>
          <button nz-button nzType="primary" type="button">
            <i nz-icon nzType="barcode" nzTheme="outline" (click)="handleBarcodeScanner()"></i>
          </button>
        </span>
      </div>
    <div class="delivery-slips">
      @if (this.deliveryNote) {
        <app-order-comments [order]="deliveryNote" ></app-order-comments>
      }
      <i class="im im-truck"></i>&nbsp;@if (deliveryNote?.trackingCode) {
      <i nz-icon [nzType]="'check-circle'" [nzTheme]="'twotone'" [nzTwotoneColor]="'#52c41a'" ></i>
    }
    @if (!deliveryNote?.trackingCode) {
      <i nz-icon [nzType]="'close-circle'" [nzTheme]="'twotone'" [nzTwotoneColor]="'#eb2f96'" ></i>
    }
  </div>
</div>

<nz-spin [nzSpinning]="loading">
  <nz-divider></nz-divider>
  @if (cartonStep) {
    <div class="carton-step">
      <p class="carton-step__hint">Kartons erfassen oder ohne Kartons ausliefern:</p>
      <div class="carton-grid">
        @for (type of cartonTypes; track type.id) {
          <div class="carton-btn-wrap">
            <button nz-button nzType="default" class="carton-btn" (click)="incrementCarton(type.id)">
              <span class="carton-btn__name">{{type.name}}</span>
              <span class="carton-btn__qty">{{cartonQuantities[type.id] || 0}}</span>
            </button>
            @if ((cartonQuantities[type.id] || 0) > 0) {
              <button nz-button nzType="text" class="carton-btn__minus" (click)="decrementCarton(type.id)">−</button>
            }
          </div>
        }
      </div>
    </div>
  }
  @if (!cartonStep) {
  <nz-row >
    <nz-col nzFlex="24">
      @if (isProcessedCorrect) {
        <div class="processed-correct">
          <span nz-icon [nzType]="'check-circle'"></span>
          RICHTIG VERARBEITET
        </div>
      }
      @if (!isProcessedCorrect) {
        <nz-table
          #tableRef
          nzShowSizeChanger
          [nzData]="deliveryNote?.articles"
          [nzShowPagination]="false"
          class="articles-table"
          >
          <thead>
            <tr>
              <th>Pos.</th>
              <th>Lagerplatznr.</th>
              <th>Art-Nr.</th>
              <th>EAN</th>
              <th>Produktname</th>
              <th>ESD</th>
              <th>Menge</th>
              <th>Gescannt</th>
              <th nzWidth="48px"></th>
            </tr>
          </thead>
          <tbody>
            @for (variant of deliveryNote?.articles; track variant; let i = $index) {
              <tr [class]="(variant.isFull() ? 'finished' : (variant.scanned > 0 ? 'partly-finished':''))" (dblclick)="markAsFull(variant.id)">
                <td>{{i + 1}}</td>
                <td>{{variant.storageLocationNumber}}</td>
                <td>{{variant.orderNumber}}</td>
                <td>{{variant.ean}}</td>
                <td>{{variant.name}}</td>
                <td>{{variant.isEsd | booleanFormat}}</td>
                <td>{{variant.quantity}} {{variant.packUnit}}</td>
                <td>{{(variant.scanned ? variant.scanned : 0)}} {{variant.packUnit}}</td>
                <td>
                  <div class="actions">
                    <span nz-icon
                      [nzType]="'check-circle'"
                      [nzTheme]="'twotone'" [nzTwotoneColor]="'#52c41a'"
                      (click)="markAsFull(variant.id)"
                      nz-tooltip
                      nzTooltipTitle="als vollständig markieren"
                    ></span>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </nz-table >
      }
    </nz-col>
  </nz-row>
  <div class="ean-scanner--container">
    <span>Artikel scannen: </span><input [(ngModel)]="ean" (ngModelChange)="handleEANScan($event)" #eanField>
  </div>
  }
</nz-spin>

</ng-template>

<ng-template #modalFooter>
  <nz-row class="ship-footer">
    <nz-col >
      @if (!cartonStep) {
        <button nz-button nzType="default"
          nz-popconfirm
          nzPopconfirmTitle="Es gibt keine Möglichkeit, dies rückgängig zu machen. Stellen Sie sicher, dass Sie die Bestellung als 'Komplett ausgeliefert' umstellen möchten"
          nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="handleForceFinish()"
          [disabled]="!deliveryNote || !deliveryNote.orderCompleted || !!deliveryNote.trackingCode"
        >Bestellung ohne Versandetikette ausliefern</button>
        <button nz-button nzType="default"
          (click)="notCompletedOrder(reasonTpl)"
          [disabled]="!this.deliveryNote"
        >Bestellung auf "Position unvollständig" setzen</button>
      }
      @if (cartonStep) {
        <button nz-button nzType="primary"
          (click)="finishOrder()"
          [disabled]="cartonTotal === 0"
          [nzLoading]="loading"
        >Versand abschließen</button>
        <button nz-button nzType="default"
          nz-popconfirm
          nzPopconfirmTitle="Bestellung ohne Kartons abschließen?"
          nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="finishWithoutCartons()"
          [disabled]="loading"
        >Ohne Kartons ausliefern</button>
      }
    </nz-col>
    @if (!cartonStep) {
      <nz-col nzFlex="6">
        <button nz-button nzType="default" (click)="handleCancel()">Schließen</button>
      </nz-col>
    }
  </nz-row>

</ng-template>
</nz-modal>

<app-document-pdf-safari-modal [pdfLink]="pdfLink"></app-document-pdf-safari-modal>

<ng-template #reasonTpl>
  <label for="">Interner Kommentar</label>
  <textarea rows="4" nz-input [(ngModel)]="uncompletedReason" ></textarea>
</ng-template>

